import * as React from "react";
import * as ReactDOM from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import { getTimeType } from "actions/timeType.action";

export const TimeLoader = (props) => {
  const dispatch = useDispatch();
  const { TimeList } = useSelector((state) => state.timeTypes);

  React.useEffect(() => {
    dispatch(getTimeType());
  }, []);

  React.useEffect(() => {
    if (TimeList) {
      const data = TimeList?.data ?? [];
      props.onDataReceived(data);
    }
  }, [TimeList]);

  return !TimeList ? <LoadingPanel /> : null;
};

const LoadingPanel = () => {
  const loadingPanel = (
    <div className="k-loading-mask">
      <span className="k-loading-text">Loading</span>
      <div className="k-loading-image" />
      <div className="k-loading-color" />
    </div>
  );
  const gridContent = document && document.querySelector(".k-grid-content");

  return gridContent
    ? ReactDOM.createPortal(loadingPanel, gridContent)
    : loadingPanel;
};
